/* Default PLP presentation, migrated from the Visually experiment. */
(function () {
  'use strict';
  if (window.cseDefaultCardsLoaded) return;
  window.cseDefaultCardsLoaded = true;
  const rootSelector = '#productGridContainer[data-default-plp]';
  const instances = new Map();

function getColorForPack(text, fullTitle = "") {
  const t = text.toUpperCase();
  const ft = fullTitle.toUpperCase();

  let bg = '#F2ECE5';
  let color = '#000000';

  if (t.includes('30 SERVING') || t.includes('30-SERVING')) {
    bg = '#F2ECE5';
    color = '#000000';
  }
  else if (t.includes('20 SERVING') || t.includes('20-SERVING')) {
    bg = '#F6DC90';
    color = '#000000';
  }
  else if (t.includes('10 PACKET') || t.includes('10-PACK') || t.includes('10 PACK') || t.includes('10 SERVING') || t.includes('10 SINGLE')) {
    bg = '#FBC895';
    color = '#000000';
  }
  else if (t.includes('8-PACK') || t.includes('8 SINGLE') || t.includes('8 PACK') || t.includes('8 PACKET')) {
    bg = '#FBC895';
    color = '#000000';
  }
  else if (t.includes('6-PACK') || t.includes('6 PACK') || t.includes('6 PACKET') || t.includes('BYO') || ft.includes('BUILD YOUR OWN') || ft.includes('BYO')) {
    bg = '#F0E6CC';
    color = '#000000';
  }
  else if (t.includes('12-PACK') || t.includes('12 PACK') || t.includes('12 SERVING') || t.includes('12 OZ') || t.includes('12-OZ')) {
    if (ft.includes('16 OZ') || ft.includes('16-OZ') || t.includes('16 OZ') || t.includes('16-OZ')) {
      bg = '#F1A35B';
      color = '#000000';
    } else {
      bg = '#B78552';
      color = '#FFFFFF';
    }
  }

  return { bg, color };
}


  function mount(root) {
    if (instances.has(root)) return;
    const originals = new WeakMap();
    let frame = 0;
    let badgeTimer = 0;
    let pendingBadges = false;

    function tagPrices(card) {
      const price = card.querySelector('.comparing-prices, .ae--product-card-price');
      if (!price) return;
      price.classList.add('vsly-price-container');
      Array.from(price.childNodes).forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) node.remove();
      });
      price.querySelectorAll('s, strike, del, [style*="line-through"], [class*="compare" i], [class*="old" i], [class*="regular" i]').forEach(el => {
        if (el.tagName !== 'DIV') el.classList.add('vsly-compare-price');
      });
    }

    function processCard(card) {
      tagPrices(card);
      const title = card.querySelector('.ae--product-card-title');
      const info = card.querySelector('.ae--product-card-custom_info');
      const bottom = card.querySelector('.ae--product-card-bottom-section');
      if (!title || !bottom) return;
      let data = originals.get(card);
      if (!data) {
        const originalTitle = title.textContent.trim();
        const badge = card.querySelector('.stamped-product-reviews-badge');
        const fullTitle = badge?.getAttribute('data-product-title') || card.querySelector('img')?.alt || originalTitle;
        let pack = '';
        const match = originalTitle.match(/^(.*?)(?:\s*\((.*?)\))?$/);
        if (match?.[2]) {
          title.textContent = match[1].trim();
          pack = match[2].trim();
        }
        if (!pack && info) {
          const infoMatch = info.textContent.trim().match(/^(.*?)(?:\s*\((.*?)\))?$/);
          if (infoMatch?.[2]) {
            info.textContent = infoMatch[1].trim();
            pack = infoMatch[2].trim();
          }
        }
        if (!pack) {
          const fallback = fullTitle.match(/(\d+(?:\s|-)*(?:Pack|Servings?|oz|ounce))/i);
          if (fallback) pack = fallback[1].replace('-', ' ').toUpperCase();
        }
        data = { pack, fullTitle };
        originals.set(card, data);
      }
      // Keep the banner in sync with the actual selected size when variants change.
      const selector = card.querySelector('[data-product-card-selector]');
      let pack = data.pack;
      if (selector) {
        const selected = selector.querySelector('[data-option-name*="serving"] .is-selected, [data-option-name*="size"] .is-selected, [data-option-name*="pack"] .is-selected');
        if (selected?.dataset.optionValue) {
          pack = selected.querySelector('.ae--product-card-selector__label-full')?.textContent.trim() || selected.dataset.optionValue;
        }
      }
      /*let banner = bottom.querySelector('.vsly-pack-banner');
      if (pack) {
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'vsly-pack-banner';
          bottom.insertBefore(banner, bottom.firstChild);
        }
        const colors = getColorForPack(pack, data.fullTitle);
        if (banner.textContent !== pack) banner.textContent = pack;
        banner.style.backgroundColor = colors.bg;
        banner.style.color = colors.color;
      } */
    }

    function evaluateEyebrows() {
      const titles = Array.from(root.querySelectorAll('.ae--product-card-title'));
      const params = new URLSearchParams(location.search);
      const filtered = Array.from(params.keys()).some(key => key.startsWith('filter.') || key === 'sort_by' || key === 'q');
      const unique = new Set(titles.map(el => el.textContent.trim()).filter(Boolean));
      titles.forEach(el => {
        // Cards without a separate flavor title must keep their product title.
        el.hidden = !filtered && unique.size === 1 && !!el.closest('.ae--product-card').querySelector('.ae--product-card-custom_info');
      });
    }

    function refresh() {
      frame = 0;
      observer.disconnect();
      root.querySelectorAll('.ae--product-card').forEach(processCard);
      evaluateEyebrows();
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id'] });
      if (pendingBadges) {
        pendingBadges = false;
        clearTimeout(badgeTimer);
        badgeTimer = setTimeout(() => window.StampedFn?.loadBadges?.(), 50);
      }
    }

    function schedule(badges = false) {
      pendingBadges = pendingBadges || badges;
      if (!frame) frame = requestAnimationFrame(refresh);
    }

    const observer = new MutationObserver(mutations => {
      let changed = false;
      let newCards = false;
      mutations.forEach(mutation => {
        if (mutation.target instanceof Element && mutation.target.closest('.vsly-price-container, .comparing-prices, .ae--product-card-price')) changed = true;
        [...mutation.addedNodes, ...mutation.removedNodes].forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches('.ae--product-card') || node.querySelector('.ae--product-card')) {
            changed = true;
            newCards = true;
          }
          if (node.matches('.comparing-prices, .ae--product-card-price')) changed = true;
        });
      });
      if (changed) schedule(newCards);
    });
    instances.set(root, { schedule, destroy() {
      observer.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(badgeTimer);
    } });
    pendingBadges = true;
    refresh();
  }

  function setup() {
    instances.forEach((instance, root) => {
      if (!root.isConnected) { instance.destroy(); instances.delete(root); }
    });
    document.querySelectorAll(rootSelector).forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
  document.addEventListener('FiltersUpdated', () => {
    setup();
    instances.forEach(instance => instance.schedule(true));
  });
  window.addEventListener('popstate', () => instances.forEach(instance => instance.schedule()));
})();
